export default __webpack_public_path__ + "static/media/avatar_7.d624cbf8.png";